<template>
  <v-container>
    <v-layout row wrap class="mb-5">
      <v-flex xs12 md12>
        <v-layout align-center>
          <h1 class="primary--text mr-3">Categories</h1>
          <v-btn small depressed color="accent" to="/categories/create">
            <v-icon small>add</v-icon>Create Category
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Search" single-line></v-text-field>
        </v-layout>
      </v-flex>
    </v-layout>

    <app-alert
      class="mb-3"
      type="success"
      message="Category successfully created."
      v-if="$route.query.categoryCreated"
    />
    <!-- <app-alert class="mb-3" type="success" :message="category.updated" /> -->

    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title class="subheading font-weight-bold px-4">
            <span v-if="search !== ''">Results for "{{ search }}"</span>
            <span v-else>All Categories</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="headers"
            :items="categories"
            :loading="categoriesLoading"
            :search="search"
            :rows-per-page-items="[30, 60, 100]"
            no-data-text="No categories available"
          >
            <template v-slot:items="props">
              <td> {{ (props.index + 1) }} </td>
              <td v-if="category.editing === props.item._id">
                <v-text-field v-model="category.cached.name" @input="category.canSave = true"></v-text-field>
              </td>
              <td v-else>{{ props.item.name }}</td>

              <td v-if="category.editing === props.item._id">
                <v-select
                  v-model="category.cached.sector_id"
                  :items="sectorOptions"
                  @input="category.canSave = true"
                ></v-select>
              </td>
              <td v-else>{{ props.item.sector }}</td>

              <td v-if="category.editing === props.item._id">
                <v-select
                  v-model="category.cached.status"
                  :items="statusOptions"
                  @input="category.canSave = true"
                ></v-select>
              </td>
              <td v-else>
                <v-chip
                  small
                  :color="props.item.status === 'active' ? 'green' : 'red'"
                  text-color="white"
                >{{ $lang(props.item.status) }}</v-chip>
              </td>

              <td v-if="category.editing === props.item._id">
                <v-btn
                  small
                  depressed
                  color="success"
                  @click="updateCategory()"
                  :disabled="category.isSaving || !category.canSave"
                >Save</v-btn>
                <v-btn small flat @click="cancelEdit()" :disabled="category.isSaving">Cancel</v-btn>
              </td>
              <td v-else>
                <v-icon small class="mr-2" @click="editMode(props.item)">edit</v-icon>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { FETCH_CATEGORY, UPDATE_CATEGORY } from '@/store/actions/category'
import { SECTOR_FETCH } from '@/store/actions/sector'
import { statusOptions } from '@/data/options'

export default {
  name: 'Categories',
  created () {
    this.sectorsLoading = true
    this.categoriesLoading = true
    this.$store.dispatch(SECTOR_FETCH)
      .finally(() => (this.sectorsLoading = false))
    this.$store.dispatch(FETCH_CATEGORY, { model: 'category' })
      .finally(() => (this.categoriesLoading = false))
  },
  data () {
    return {
      search: this.$route.query.s || '',
      category: {
        editing: null,
        cached: null,
        updated: false,
        canSave: false,
        isSaving: false
      },
      categoriesLoading: false,
      sectorsLoading: false,
      statusOptions: statusOptions,
      headers: [
        { text: '#', value: 'index', sortable: false },
        { text: 'Name', value: 'name' },
        { text: 'Sector', value: 'sector' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    }
  },
  computed: {
    categories () {
      return this.$store.getters.categories('aid').map(category => {
        category.sector = this.sectorName(category.sector_id)
        return category
      })
    },
    sectorOptions () {
      return this.$store.getters.sectorsAsOptions
    }
  },
  methods: {
    sectorName (id) {
      return this.$store.getters.sectorName(id)
    },
    editMode (category) {
      this.category.canSave = false
      this.category.updated = false
      this.category.editing = category._id
      this.category.cached = Object.assign({}, category)
      delete this.category.cached.created // removes the created timestamp
      delete this.category.cached.modified // removes the modified timestamp
    },
    updateCategory () {
      this.category.isSaving = true
      delete this.category.cached.sector // removes the created timestamp
      this.$store.dispatch(UPDATE_CATEGORY, { model: 'category', data: this.category.cached })
        .then(() => {
          this.category.updated = 'Category has been successfully updated.'
        })
        .finally(() => {
          this.category.canSave = false
          this.category.editing = null
          this.category.cached = null
          this.category.isSaving = false
        })
    },
    cancelEdit () {
      this.category.canSave = false
      this.category.editing = null
      this.category.cached = null
    }
  }
}
</script>
